import React from 'react';
import ReactPlayer from 'react-player';
import { PDFdownloadButton } from './Pdf';
import { VideoGateContext } from '../VideoGateContext';

export const VideoAndShowPDFAfter = ({ vidSrc, pdfFile }) => {
  const [ended, setEnded] = React.useState(false);
  const onEnd = () => {
    setEnded(true);
  };

  const pdfItems = Array.isArray(pdfFile)
    ? pdfFile.filter((pdf) => pdf?.url)
    : pdfFile?.url
      ? [pdfFile]
      : [];

  return (
    <VideoSlide vidSrc={vidSrc} onEnd={onEnd}>
      <div>
        <div className='flex flex-col gap-4 items-left'>
          {ended &&
            pdfItems.map((pdf, index) => (
              <PDFdownloadButton key={index} href={pdf.url}>
                {pdf.name}
              </PDFdownloadButton>
            ))}
        </div>
      </div>
    </VideoSlide>
  );
};

const VideoSlide = ({ vidSrc, onEnd = false, children = false }) => {
  const { registerVideoRequirement, markVideoCompleted } =
    React.useContext(VideoGateContext);
  const videoUrl =
    typeof vidSrc === 'number' || /^\d+$/.test(String(vidSrc))
      ? `https://vimeo.com/${vidSrc}`
      : vidSrc;

  React.useEffect(() => {
    registerVideoRequirement();
  }, [registerVideoRequirement]);

  return (
    <>
      <div className=' max-w-[1000px] mx-auto w-full flex flex-col gap-8 '>
        <div className='aspect-[16/9] mx-auto flex items-center justify-center text-center w-full fasc-video-container  '>
          <ReactPlayer
            className='w-full h-full'
            url={videoUrl}
            controls={true}
            width='100%'
            height='100%'
            onEnded={() => {
              markVideoCompleted();

              if (onEnd) {
                onEnd();
              }
            }}
          />
        </div>
        {children && <div className=''>{children}</div>}
      </div>
    </>
  );
};

export default VideoSlide;
